/**
 * Returns true when `path` is a safe same-origin redirect path.
 *
 * Shared by every consumer that decides where to navigate a materialized session: the
 * query-parameter redirect (`login-form.ts`) and the role-provided `defaultRedirection`
 * (capability `frontend-role-ui-preferences`) MUST be judged by the exact same rule, or a role
 * value editable in the admin CRUD would become an open-redirect primitive the query-param path
 * already guards against.
 *
 * Rejects:
 * - Absolute URLs (http://, https://, protocol-relative //)
 * - Paths containing backslash (Windows-style traversal some browsers honour)
 * - Anything that does not start with a single forward slash
 */
export const isSafeRedirectPath = (path: string | null): path is string => {
  if (!path) return false;
  if (/^https?:\/\//i.test(path)) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('\\')) return false;
  return path.startsWith('/');
};
